var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKhToggle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62064 6.66602C3.27773 6.66602 3 6.94082 3 7.2796C3 7.6184 3.27796 7.89319 3.62064 7.89319H14.1725C14.5154 7.89319 14.7931 7.61839 14.7931 7.2796C14.7931 6.94059 14.5151 6.66602 14.1725 6.66602H3.62064ZM3.62064 12.1888C3.27773 12.1888 3 12.4636 3 12.8024C3 13.1412 3.27796 13.416 3.62064 13.416H20.3794C20.7223 13.416 21 13.1412 21 12.8024C21 12.4634 20.722 12.1888 20.3794 12.1888H3.62064ZM3.62064 17.7116C3.27773 17.7116 3 17.9864 3 18.3252C3 18.664 3.27796 18.9387 3.62064 18.9387H14.1725C14.5154 18.9387 14.7931 18.6639 14.7931 18.3252C14.7931 17.9861 14.5151 17.7116 14.1725 17.7116H3.62064Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKhToggle);
export default __webpack_public_path__ + "static/media/kh-toggle.d7b47cb97332f67e53210d21a265d19d.svg";
export { ForwardRef as ReactComponent };